<template>
  <div class="row">
    <div class="col-md-10">
      <b-form-group
        :label="$t('message.lblRok')">
        <b-form-select
          v-model="searchDanovnik.rok"
          :options="roks"/>
      </b-form-group>

      <b-form-group
        :label="$t('message.lblTyp')">
        <b-form-radio-group
          v-model.trim="searchDanovnik.typ"
          plain>
          <b-form-radio value="a">A</b-form-radio>
          <b-form-radio value="b">B</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <b-form-group :label="$t('message.lblPriez')">
        <b-form-input
          class="alignL"
          v-model="searchDanovnik.priezvisko"/>
      </b-form-group>

      <b-form-group :label="$t('message.lblDic')+' / '+$t('message.lblRc')">
        <b-form-input
          class="alignL"
          v-model="searchDanovnik.dic"/>
      </b-form-group>

    </div>
    <div class="col-md-2"/>
  </div>
</template>

<script>
import bFormGroup from '@/components/form-group-col5';
import textGroup from '@/components/extractor/textGroup.vue';

export default {

  components: {
    bFormGroup,
    textGroup,
  },

  props: {
    searchDanovnik: {
      type: Array,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      roks: [
        { value: null, text: '' },
        { value: '20', text: '2020' },
        { value: '19', text: '2019' },
        { value: '18', text: '2018' },
        { value: '17', text: '2017' },
        { value: '16', text: '2016' },
        { value: '15', text: '2015' },
        { value: '14', text: '2014' },
        { value: '13', text: '2013' }
      ],
    };
  },

};
</script>

<style scoped>
.p12 .form-check {
    width: 12%;
}
.item-title {
    margin-top: 3.5%;
    text-align: right;
    font-weight: bold;
}
.pull-right {
    float: right;
}
.remove-item {
    display: inline !important;
    margin-left: 1em !important;
}
</style>
